export function stable<T>(x: T) {
  return JSON.stringify(x, Object.keys(x ?? {}).sort())
}

export const hash = (...xs: unknown[]) => {
  const s = xs.map(stable).join('|')
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  return `h${(h >>> 0).toString(16)}`
}
